import {createFileRoute} from '@tanstack/react-router'

import OverviewScreen from '@protected/overview'

export const Route = createFileRoute('/_protected/')({component: OverviewScreen})
